import { Box, Button, Typography } from "@mui/material";
import { ConnectionDto } from "@arelia-types/connection";
import ConnectionCard from "./ConnectionCard";
import BasicDialog from "../dialogs/BasicDialog";
import { useState } from "react";
import AppleIcon from "@mui/icons-material/Apple";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import { useConfiguration } from "../../../../api/configuration";
import { formatRelativeTime } from "@arelia-utils/helpers/dates";
import { trackAppDownload } from "src/api/beacons";
import { ArelTooltip } from "@arelia-components/ui-atoms/Tooltip";

type Props = {
  connection: ConnectionDto,
}

enum OSType {
  win = 'win',
  mac = 'mac'
}

export default function AreliaAuthConnection({ connection }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const { newerVersion } = connection;
  const { data: config } = useConfiguration();

  const downloadApp = (osType: OSType) => () => {
    window.open(osType === OSType.mac ? config?.applicationInstallerMacOSUrl : config?.applicationInstallerWindowsUrl, "_blank");
    trackAppDownload(osType);
    setOpen(false);
  }

  const renderStatus = () => (newerVersion &&
    <Typography variant="body2" fontStyle="italic">
      New version {newerVersion} is available
    </Typography>
  )

  const areliaMessages = {
    connected: "Arelia Authenticator is successfully connected.",
    unconnected: "To connect, please use the Arelia Authenticator application. If it's not installed on your device, download and install it to access all Arelia features."
  }

  return <Box>
    <ConnectionCard {...connection}
      iconRadius="initial"
      renderConnectedStatus={renderStatus}
      onConnect={() => setOpen(true)}
    />
    {open && <BasicDialog
      connection={connection}
      onClose={() => setOpen(false)}
      renderActions={() => <>
        <Typography variant="body1" sx={{ marginRight: "8px" }}>Download: </Typography>
        <ArelTooltip title={config?.applicationInstallerWindowsUrl ? "" : "App is in development and will be released soon"}>
          <span>
            <Button
              variant="outlined"
              onClick={downloadApp(OSType.win)}
              startIcon={<MicrosoftIcon />}
              disabled={!config?.applicationInstallerWindowsUrl}
            >
              Windows
            </Button>
          </span>
        </ArelTooltip>
        <ArelTooltip title={config?.applicationInstallerMacOSUrl ? "" : "App is in development and will be released soon"}>
          <span>
            <Button
              variant="outlined"
              onClick={downloadApp(OSType.mac)}
              startIcon={<AppleIcon />}
              sx={{ marginLeft: "8px" }}
              disabled={!config?.applicationInstallerMacOSUrl}
            >
              Mac OS
            </Button>
          </span>
        </ArelTooltip>
      </>}
    >
      {connection.connected ? <>{areliaMessages.connected} {connection.newerVersion ? `New version ${connection.newerVersion} is available` : ""}</> : areliaMessages.unconnected}
      <Typography sx={{ marginTop: "20px" }}>Latest version: <strong>{config?.appVersion}</strong></Typography>
      {connection.connected && (<Box sx={{ marginTop: "20px" }}>
        {connection.sessions.map(s => (<Typography>Connected {formatRelativeTime(s.connectedOn)} with version <strong>{s.version}</strong></Typography>))}
      </Box>)}

    </BasicDialog>}
  </Box>;
}